import React from 'react';
import AxisConfigurationPanel from './AxisConfigurationPanel';

export default function ReportMetricFields({ embedded = false, ...props }) {
  return <AxisConfigurationPanel embedded={embedded} {...props} />;
}
